import React, { FC, useContext, useEffect, useState } from "react";
import { Button, FluentProvider, webLightTheme, Body1Strong } from "@fluentui/react-components";
import { Delete20Regular, Add20Regular, ArrowDown20Filled, ArrowUp20Filled } from "@fluentui/react-icons";
import { Stack, StackItem } from "@fluentui/react";
import { dashboardTheme, primaryIcon, secondaryIcon } from "../../styles/customStyles";
import { CheckBox } from "../../components/checkbox/checkbox_component";
import { GlobalContext } from "../../hooks/globalContext";
import { Dropdown, Option, useId } from "@fluentui/react-components";
import { dropdownDataStyle } from "../../styles/customStyles";

interface Field {
    key: string;
    name: string;
    priority: number;
    display: any;
}

interface ManageViewProps {
    overlayopen: boolean;
    setOverlayOpen: any;
}

const ManageView: FC<ManageViewProps> = ({ overlayopen, setOverlayOpen }) => {
    const contextValue: any = useContext(GlobalContext);

    const [fields, setFields] = useState<Field[]>([]);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [dropDownValue, setDropDownValue] = useState({});
    const dropdownId = useId("dropdown-default");
    const [currentDisplayColumnsData, setCurrentDisplayColumnsData] = useState([]);
    const [hiddenColumnsData, setHiddenColumnsData] = useState([]);
    // const [selectedVal, setSelectedVal] = React.useState(defaultSelected : '');

    const addField = () => {
        const newDisplayColumnsArr = JSON.parse(JSON.stringify(currentDisplayColumnsData));
        const newHiddenColumnsArr = JSON.parse(JSON.stringify(hiddenColumnsData));
        
        let displayArrIndex = newDisplayColumnsArr.length;
        let hiddenArrIndex = 0;

        const newDisplayColumnItem = newHiddenColumnsArr[hiddenArrIndex];
        // newDisplayColumnItem.display = {"table": "Yes", "filter": "Yes"};
        newDisplayColumnItem.display = {
            "table": "Yes",
            "filter": newDisplayColumnItem.name.includes("UTC") ? "No" : "Yes"
        };
        newDisplayColumnItem.priority = newDisplayColumnsArr[displayArrIndex-1].priority + 1;
        console.log("newDisplayColumnItem",newDisplayColumnItem.name)


        newHiddenColumnsArr.shift();
        setHiddenColumnsData(newHiddenColumnsArr);
        setCurrentDisplayColumnsData([...currentDisplayColumnsData, newDisplayColumnItem]);
    };

    const deleteField = (index: number) => {
        if (index === 0) return; // Prevent deletion for the first column

        const newDisplayColumnsArr = [];
        const newHiddenColumnsArr = JSON.parse(JSON.stringify(hiddenColumnsData));

        currentDisplayColumnsData.map((val, i) => {
            if(i === index){
                newHiddenColumnsArr.push({...val, "display": {"table": "No", "filter": "No"}});
            }else{
                newDisplayColumnsArr.push(val);
            }
        });

        setCurrentDisplayColumnsData(newDisplayColumnsArr);
        setHiddenColumnsData(newHiddenColumnsArr);
    };

    const toggleSelectField = (index: number) => {
        if (index === 0) return; // Prevent checkbox toggle for the first column

        const newFields = currentDisplayColumnsData.map((field, i) => ({
            ...field,
            selected: i === index ? (field.selected !== undefined ? !field.selected : true) : false,
        }));

        setCurrentDisplayColumnsData(newFields);
        setSelectedIndex(newFields[index].selected ? index : null);
    };

    const moveField = (index: number, direction: number) => {
        if (index === 0) return; // Prevent movement for the first column
        
        const newFields = JSON.parse(JSON.stringify(currentDisplayColumnsData));

        const targetIndex = index + direction;
        if (targetIndex >= 0 && targetIndex < newFields.length) {
            [newFields[index], newFields[targetIndex]] = [
                newFields[targetIndex],
                newFields[index],
            ];
            setCurrentDisplayColumnsData(newFields);
            setSelectedIndex(targetIndex);
        }
    };

    const handleDropDown = (option, priority) => {
        const newDisplayColumnsArr = JSON.parse(JSON.stringify(currentDisplayColumnsData));
        const newHiddenColumnsArr = JSON.parse(JSON.stringify(hiddenColumnsData));
        
        let displayArrIndex = -1;
        let hiddenArrIndex = -1;
        currentDisplayColumnsData.map((val, i) => val.priority === priority && (displayArrIndex = i));
        hiddenColumnsData.map((val, i) => val.priority === option.priority && (hiddenArrIndex = i));
        
        if(displayArrIndex > -1 && hiddenArrIndex > -1){
            const currentDisplayName = newDisplayColumnsArr[displayArrIndex].name;
            const currentDisplayKey = newDisplayColumnsArr[displayArrIndex].key;

            newDisplayColumnsArr[displayArrIndex].name = newHiddenColumnsArr[hiddenArrIndex].name;
            newDisplayColumnsArr[displayArrIndex].key = newHiddenColumnsArr[hiddenArrIndex].key;

            newHiddenColumnsArr[hiddenArrIndex].name = currentDisplayName;
            newHiddenColumnsArr[hiddenArrIndex].key = currentDisplayKey;
        }
        
        setHiddenColumnsData(newHiddenColumnsArr);
        setCurrentDisplayColumnsData(newDisplayColumnsArr);
    }

    useEffect(() => {
        const tempColumnsArr = [];

        contextValue.manageViewDropDownData.forEach((val, i) => {
            tempColumnsArr.push(val)
        });

        const currentDisplayColumnsData = contextValue.manageViewDropDownData.filter((val) => val.display.table.toLocaleLowerCase() === "yes");

        const hiddenColumnsData = contextValue.manageViewDropDownData.filter((val) => val.display.table.toLocaleLowerCase() === "no");
        
        setFields(tempColumnsArr);
        setHiddenColumnsData(hiddenColumnsData);
        setCurrentDisplayColumnsData(currentDisplayColumnsData);
    }, []);

    useEffect(() => {
      contextValue.setManageViewDropDownData([...currentDisplayColumnsData, ...hiddenColumnsData]);
    }, [currentDisplayColumnsData, hiddenColumnsData])

    return (
        <FluentProvider theme={dashboardTheme}>
            <Stack tokens={{ childrenGap: 15, padding: 10 }}>
                {/* Move Buttons */}
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <Button
                        icon={selectedIndex === null || selectedIndex === 1
                            ? (<ArrowUp20Filled {...secondaryIcon} />)
                            : (<ArrowUp20Filled {...primaryIcon} />)
                        }
                        appearance="subtle"
                        onClick={() => selectedIndex !== null && moveField(selectedIndex, -1)}
                        disabled={selectedIndex === null || selectedIndex === 1}
                    >
                        Move up
                    </Button>
                    <Button
                        icon={selectedIndex === null || selectedIndex === currentDisplayColumnsData.length - 1
                            ? (<ArrowDown20Filled {...secondaryIcon} />)
                            : (<ArrowDown20Filled {...primaryIcon} />)
                        }
                        appearance="subtle"
                        onClick={() => selectedIndex !== null && moveField(selectedIndex, 1)}
                        disabled={
                            selectedIndex === null || selectedIndex === currentDisplayColumnsData.length - 1
                        }
                    >
                        Move down
                    </Button>
                </Stack>

                <Body1Strong>Column Name</Body1Strong>

                {/* Field List */}
                <Stack tokens={{ childrenGap: 10 }}>
                    {currentDisplayColumnsData.map((field, index) => (
                        <StackItem key={field.priority}>
                            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
                                <StackItem>
                                    {/* Grab icon (if needed) */}
                                </StackItem>
                                <StackItem>
                                    <CheckBox
                                        checked={field.selected !== undefined ? field.selected : false}
                                        onChange={() => toggleSelectField(index)}
                                        disabled={index === 0} // Disable checkbox for the first column
                                    />
                                </StackItem>
                                <StackItem grow>
                                    <Stack>
                                        <StackItem>
                                            <Dropdown
                                                size="small"
                                                // value={selectedVal}
                                                aria-labelledby={dropdownId}
                                                placeholder="Select"
                                                aria-required={true}
                                                disabled={index === 0 ? true : false}
                                                defaultValue={field.name}
                                                defaultSelectedOptions={[field.key]}
                                            >
                                                <div style={dropdownDataStyle}>
                                                    <>
                                                        <Option key={field.key} value={field.key}>
                                                            {field.name}
                                                        </Option>

                                                        { hiddenColumnsData.map((option: any, i: number) => (
                                                            <Option key={option.key} value={option.key} onClick={() => handleDropDown(option, field.priority) }>
                                                                {option.name}
                                                            </Option>
                                                        ))}
                                                    </>
                                                </div>
                                            </Dropdown>
                                        </StackItem>
                                    </Stack>
                                </StackItem>
                               {index!==0&& <StackItem>
                                    <Button
                                        icon={<Delete20Regular {...primaryIcon} />}
                                        appearance="subtle"
                                        onClick={() => deleteField(index)}
                                        disabled={index === 0} // Disable delete button for the first column
                                    />
                                </StackItem>}
                            </Stack>
                        </StackItem>
                    ))}
                </Stack>

                {/* Add Field Button */}
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <Button onClick={hiddenColumnsData.length > 0 ? addField : null} appearance="subtle" disabled={hiddenColumnsData.length > 0 ? false : true}>
                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>{hiddenColumnsData.length > 0 ? <Add20Regular {...primaryIcon} /> : <Add20Regular {...secondaryIcon} />}</StackItem>
                            <StackItem><Body1Strong>Add column</Body1Strong></StackItem>
                        </Stack>
                    </Button>
                </Stack>
            </Stack>
        </FluentProvider>
    );
};

export default ManageView;